import { type ChartLegendProps } from '../ChartLegend';
import { type ChartValuesAmount, type ChartValuesCount } from 'src/shared/types/chartsData';
import { DATASET_SOURCE_COLORS } from 'src/shared/types/charts';
import moment from 'moment';

export const percent = (value: number, total: number) => {
  if (total === 0) return 0;
  return Math.min(Math.floor((value / total) * 100), 100);
};

export const formatCompanyCutoffDateToDisplay = (cutoffDay: number | undefined, now: Date = new Date()) => {
  if (!cutoffDay) {
    return '--/--/----';
  }
  const month = now.getMonth();
  const year = now.getFullYear();

  if (Number(cutoffDay) === 32) {
    return moment(now).endOf('month').format('DD/MM/YYYY');
  }
  return moment([year, month, cutoffDay]).subtract(1, 'd').format('DD/MM/YYYY');
};

export const parseLegendKeys = (
  data: ChartValuesAmount | ChartValuesCount,
  singleColor?: DATASET_SOURCE_COLORS
): ChartLegendProps[] => {
  return Object.entries<number[] | Array<number | undefined>>(data)
    .filter(entry => !entry[1].every(value => value === undefined))
    .map((entry: [string, number[] | Array<number | undefined>]): ChartLegendProps => {
      const legendTitle = entry[0];

      return {
        legendTitle,
        circleProps: {
          id: entry[0],
          colors: singleColor ? [singleColor] : [DATASET_SOURCE_COLORS[entry[0] as keyof typeof DATASET_SOURCE_COLORS]]
        }
      };
    });
};
